import axios from 'axios';
import { QueryClient } from '@tanstack/react-query';

// Clerk exposes its instance on window after ClerkProvider mounts.
// Using it here lets the Axios interceptor get a fresh token without
// needing React hooks (which can't run in a plain module).
declare global {
  interface Window {
    Clerk?: {
      session?: { getToken: () => Promise<string | null> };
      organization?: { id: string };
    };
  }
}

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:3001',
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
  try {
    const token = await window.Clerk?.session?.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Support impersonation (platform superadmin): when an admin has started
    // a support-access session from the Platform Admin console, scope all API
    // calls to the client org instead of the admin's own org.
    const supportOrg = localStorage.getItem('sg_support_org');
    const orgId = supportOrg || window.Clerk?.organization?.id;
    if (orgId) {
      config.headers['x-clerk-org-id'] = orgId;
    }
  } catch {
    // Clerk not ready yet — request proceeds without auth headers
  }
  return config;
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export { api };
export default api;
